export enum CodigoErrorNegocio {
  PAGO_APROBADO = 'PAGOS-33',
  PAGO_PENDIENTE = 'EL pago se encuentra en un estado invalido para iniciar un proceso de pago',
  PAGO_APROBADO_CONSULTANDO = 'PAGOS-27',
  ID_PAGO_INCORRECTO = 'PAGOS-19',
  TIEMPO_SESION_EXPIRADO = 'PAGOS-26',
}

export enum CodigoError {
  ERROR_INDETERMINADO = '00',
  ERROR_NEGOCIO = '01',
}
